/* eslint-disable @typescript-eslint/no-explicit-any */
import Skeleton from 'react-loading-skeleton'
import { useAccountContext } from 'src/components/account/context'
import { useEffect, useState } from 'react'
import { getClubeCMSPage } from 'src/utils/clube/getClubeCMSPage'
import { Image } from 'src/components/ui/Image'

import IconGift from '../../../../Icons/IconGift'

import './info-modal-club.scss'

type Tag = {
  color: string
  backgroundColor: string
  text: string
}

type Benefit = {
  separator: boolean
  enableIcon: boolean
  statusIcon: boolean
  label: string
  value?: string
  description: string
}

type ClubLevel = {
  tag: Tag
  benefits: Benefit[]
  expirationDays: number
  purchaseValueForFreeShipping: number
  firstIconExpirationDays: number
  name: string
  icon: string
  ruleText: string
}

type ClubLevels = ClubLevel[]

type Question = {
  title: string
  url: string
}

type ModalContent = {
  modalCashbackCard: boolean
  modalButtonMode: 'link' | 'convite' | 'niver'
  modalTitle: string
  modalSubtitle?: string
  modalText?: string
  howToUse?: string
  modalButton?: string
  modalButtonLink?: string
  modalTiersImg?: string
  modalBanner?: string
  questions?: Question[]
}

type BenefitCard = {
  size: 'small' | 'large'
  justLoggedUser: boolean
  modalContent: ModalContent
  title: string
  icon: string
}

type BenefitCards = BenefitCard[]

export const InfoModalClube = () => {
  const { isLoggedIn } = useAccountContext()
  const [clubSections, setClubSections] = useState<any>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const getData = async () => {
      try {
        const clubData = await getClubeCMSPage({
          fromServerSide: false,
        })

        setClubSections(clubData?.data.sections)
        setIsLoading(false)
      } catch (error) {
        setClubSections([])
        setIsLoading(false)
        console.error(error)
      }
    }

    getData()
  }, [])

  const benefits: BenefitCards = clubSections?.filter(
    (section: { name: string }) =>
      section.name === '[Clube] Mosaico de Benefícios'
  )?.[0]?.data?.benefits

  const listTiers: ClubLevels = clubSections?.filter(
    (section: { name: string }) => section.name === '[Clube] Lista de Níveis'
  )?.[0]?.data?.tiers

  if (!listTiers || !benefits) {
    return null
  }

  if (isLoading) {
    return (
      <>
        <Skeleton count={1} height={223} className="mb-8" />

        <div className="px-6">
          <Skeleton count={2} height={30} />
          <div className="mt-6 mb-12">
            <Skeleton count={3} height={30} />
          </div>
        </div>
        <Skeleton count={1} height={250} />
      </>
    )
  }

  return (
    <div className="flex flex-col h-full justify-between">
      <div>
        <div>
          <Image
            src="https://decathlonstore.vtexassets.com/assets/vtex.file-manager-graphql/images/85e79a07-ce17-4ece-8a1f-17cb0bed1636___0d4db9bf23e1f89ff41c2370c9b3eeda.png"
            alt="clube modal banner"
            className="w-full"
          />
        </div>

        <div className="px-6 mt-8">
          <div className="flex flex-col gap-2 mb-[50px]">
            <p className="text-base font-semibold font-inter text-restructure-primary leading-6">
              Compre e desbloqueie benefícios exclusivos para suas compras
              online e nas lojas físicas.
            </p>
            <p className="text-sm text-secondary leading-[21px]">
              A partir da sua primeira compra, você já faz parte do Clube
              Decathlon.
            </p>
          </div>

          <div>
            <p className="text-base font-semibold text-[#101010] leading-6">
              Membros clube tem frete grátis em produtos selecionados:
            </p>

            <div className="block mt-6 w-full">
              {listTiers?.map((tier, idx) => (
                <div className="flex gap-[18px] mb-3" key={idx}>
                  <img className="w-6 h-7" src={tier.icon} alt={tier.name} />
                  <p className="flex gap-[10px] font-semibold text-sm leading-[28px]">
                    {tier.name}

                    {tier?.benefits?.map((benefit) =>
                      benefit.label === 'Frete grátis' ? (
                        <span className="font-normal text-xs leading-[28px]">
                          {benefit.value}
                        </span>
                      ) : (
                        ''
                      )
                    )}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col relative group mb-[59px] mt-[50px] max-w-[100%]">
            <p className="text-base font-semibold mb-4">
              Confira Todos os benefícios
            </p>
            <div className="w-full overflow-x-auto pb-4 gridMobilePdp">
              <div className="grid grid-cols-6 gap-2 w-max">
                {(isLoggedIn
                  ? benefits
                  : benefits.filter((benefit) => !benefit?.justLoggedUser)
                )?.map((benefit) => (
                  <button
                    key={benefit?.title}
                    className={`${
                      benefit.size
                    } p-4 bg-white border border-black/10 flex flex-col gap-2 items-start text-left transition-colors col-span-${
                      benefit.size === 'large' ? '2' : '1'
                    }`}
                  >
                    {benefit.icon ? (
                      <img
                        src={benefit.icon}
                        className="text-xl"
                        alt={benefit?.title}
                      />
                    ) : (
                      <IconGift />
                    )}
                    <span
                      className="font-semibold min-h-[48px] text-sm"
                      suppressHydrationWarning
                      dangerouslySetInnerHTML={{ __html: benefit.title }}
                    />
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full sticky bottom-0  py-[16px] px-[24px] bg-white flex justify-center border-t border-[#E1E4E7]">
        <a
          className={`w-full text-white text-center bg-[#101010] rounded-[360px] p-[16px] ${
            isLoggedIn ? 'pointer-events-none ' : ''
          }`}
          href="https://secure.decathlon.com.br/api/io/login?returnUrl=https%3A%2F%2Fwww.decathlon.com.br%2Faccount%23loginSuccess"
        >
          {isLoggedIn ? 'Você já é membro!' : 'Me tornar membro clube'}
        </a>
      </div>
    </div>
  )
}
